import { useTableDataFetch } from "./useTableDataFetch";
import { BASE_URL } from "../../../../constant/apiUrl";
import InvitationHistory from "./InvitationHistoryPending";

const PendingApprovalTable = () => {
  const { rows, loading } = useTableDataFetch({
    url: `${BASE_URL}/admin/access-request-form/find-all-pending-requests`,
    dataTransformer: (data) =>
      data.map((item) => ({
        ...item,
        country: item?.country?.name,
        countryId: item?.country?.id,
      })),
  });

  return (
    <InvitationHistory
      header="Pending approvals"
      tableData={rows}
      loading={loading}
    />
  );
};

export default PendingApprovalTable;
